<template>
  <a-modal
    title="员工列表"
    :visible="visible"
    :width="1100"
    @cancel="handleClose"
    :footer="null"
  >
    <div class="table-page-search-wrapper" style="margin-bottom: 16px">
      <a-form layout="inline">
        <a-row :gutter="48">
          <!-- 收起状态 -->
          <template v-if="!advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="项目名称">
                <a-input
                  v-model:value="queryParam.projectName"
                  placeholder="请输入"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="员工姓名">
                <a-input
                  v-model:value="queryParam.employeeName"
                  placeholder="请输入"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            
            <!-- 收起状态下的按钮 -->
            <a-col :md="8" :sm="24">
              <a-form-item>
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="handleQuery" class="search-button">
                    查询
                  </a-button>
                  <a-button style="margin-left: 8px" @click="handleReset" class="no-border-button reset-button">
                    重置
                  </a-button>
                  <a-button 
                    style="margin-left: 8px" 
                    @click="toggleAdvanced()" 
                    class="no-border-button toggle-button"
                  >
                    展开
                    <DownOutlined />
                  </a-button>
                </span>
              </a-form-item>
            </a-col>
          </template>
          
          <!-- 展开状态 -->
          <template v-else>
            <!-- 第一行 -->
            <a-col :md="8" :sm="24">
              <a-form-item label="项目名称">
                <a-input
                  v-model:value="queryParam.projectName"
                  placeholder="请输入"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="员工姓名">
                <a-input
                  v-model:value="queryParam.employeeName"
                  placeholder="请输入"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="岗位名称">
                <a-input
                  v-model:value="queryParam.jobName"
                  placeholder="请输入"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            
            <!-- 第二行 -->
            <a-col :md="8" :sm="24" class="second-row-col">
              <a-form-item label="手环名称">
                <a-input
                  v-model:value="queryParam.wristbandName"
                  placeholder="请输入"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" class="second-row-col">
              <a-form-item>
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="handleQuery" class="search-button">
                    查询
                  </a-button>
                  <a-button style="margin-left: 8px" @click="handleReset" class="no-border-button reset-button">
                    重置
                  </a-button>
                  <a-button 
                    style="margin-left: 8px" 
                    @click="toggleAdvanced()" 
                    class="no-border-button toggle-button"
                  >
                    收起
                    <UpOutlined />
                  </a-button>
                </span>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24"></a-col>
          </template>
        </a-row>
      </a-form>
    </div>

    <a-tabs v-model:activeKey="activeTab" @change="handleTabChange" class="employee-tabs">
      <a-tab-pane key="assigned" tab="已排班" />
      <a-tab-pane key="unassigned" tab="未排班" />
    </a-tabs>

    <div class="table-operations" style="margin-bottom: 16px">
      <a-button
        type="text"
        shape="circle"
        @click="handleRefresh"
        v-hasPermi="['system:attendance:employee:refresh']"
        class="refresh-icon-button"
      >
        <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
      </a-button>
      <a-button
        v-if="activeTab === 'unassigned'"
        type="primary"
        :disabled="!selectedRowKeys.length"
        :loading="assignLoading"
        @click="handleAssign"
        class="search-button"
      >
        分配到当前班次
      </a-button>
      <a-button
        v-if="activeTab === 'assigned'"
        danger
        :disabled="!selectedRowKeys.length"
        :loading="assignLoading"
        @click="handleUnassign"
      >
        移出当前班次
      </a-button>
      <a-button
        @click="handleExport"
        v-hasPermi="['system:attendance:employee:export']"
        class="export-button"
      >
        <UploadOutlined />导出
      </a-button>
    </div>

    <a-table
      :columns="tableColumns"
      :data-source="tableData"
      :pagination="false"
      :loading="loading"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
        fixed: true,
      }"
      rowKey="userId"
      size="small"
      class="optimized-table"
      @change="handleTableChange"
    />
    
    <!-- 分页组件 -->
    <div class="pagination-wrapper" v-if="tableData && tableData.length > 0">
      <div class="pagination-left">
        <span class="pagination-info">
          显示第 {{ (pagination.current - 1) * pagination.pageSize + 1 }} 到第 {{ Math.min(pagination.current * pagination.pageSize, pagination.total) }} 条数据/共 {{ pagination.total }} 条
        </span>
        <a-select
          v-model:value="pagination.pageSize"
          style="width: 100px; margin-left: 8px"
          @change="onShowSizeChange(pagination.current, pagination.pageSize)"
          class="no-border-radius-select"
        >
          <a-select-option :value="10">10条/页</a-select-option>
          <a-select-option :value="20">20条/页</a-select-option>
          <a-select-option :value="50">50条/页</a-select-option>
          <a-select-option :value="100">100条/页</a-select-option>
        </a-select>
      </div>
      <div class="pagination-right">
        <a-pagination
          :current="pagination.current"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          :show-total="false"
          @change="changeSize"
        />
        <span class="pagination-jump">
          到第
          <a-input-number
            v-model:value="jumpPage"
            :min="1"
            :max="Math.ceil(pagination.total / pagination.pageSize)"
            style="width: 60px; margin: 0 4px"
            @pressEnter="handleJumpPage"
            class="no-border-radius-input-number"
          />
          页
        </span>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import { pageWristbandEmployees } from '@/api/system/wristband'
import { listUnassignedEmployees, assignEmployees, unassignEmployees } from '@/api/system/attendance'
import {
  SearchOutlined,
  RedoOutlined,
  UploadOutlined,
  UpOutlined,
  DownOutlined,
} from '@ant-design/icons-vue'

export default {
  name: 'EmployeeListModal',
  components: {
    SearchOutlined,
    RedoOutlined,
    UploadOutlined,
    UpOutlined,
    DownOutlined,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    attendanceId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      assignLoading: false,
      activeTab: 'assigned',
      selectedRowKeys: [], // 选中的行key数组
      selectedRows: [], // 选中的行数据数组
      advanced: false, // 高级搜索 展开/收起
      queryParam: {
        projectName: undefined,
        employeeName: undefined,
        jobName: undefined,
        wristbandName: undefined,
      },
      tableData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      // 跳转页码
      jumpPage: 1,
      columns: [
        {
          title: '项目名称',
          dataIndex: 'projectName',
          align: 'center',
        },
        {
          title: '员工姓名',
          dataIndex: 'employeeName',
          align: 'center',
        },
        {
          title: '岗位名称',
          dataIndex: 'jobName',
          align: 'center',
        },
        {
          title: '手环名称',
          dataIndex: 'wristbandName',
          align: 'center',
        },
      ],
    }
  },
  computed: {
    /**
     * 表格列配置（使用 computed 以便在 customRender 中访问 this）
     */
    tableColumns() {
      const that = this
      return [
        {
          title: '序号',
          dataIndex: 'id',
          width: 80,
          align: 'center',
          customRender: ({ index }) => {
            const current = that.pagination.current || 1
            const pageSize = that.pagination.pageSize || 10
            const currentIndex = (index !== undefined && index !== null) ? Number(index) : 0
            if (isNaN(currentIndex) || isNaN(current) || isNaN(pageSize)) {
              return currentIndex + 1
            }
            return (current - 1) * pageSize + currentIndex + 1
          },
        },
        ...this.columns, // 保留其他列配置
      ]
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.init()
      }
    },
    attendanceId() {
      if (this.visible) {
        this.init()
      }
    },
  },
  methods: {
    init() {
      this.pagination.current = 1
      this.pagination.total = 0
      this.jumpPage = 1
      this.tableData = []
      this.selectedRowKeys = []
      this.selectedRows = []
      this.activeTab = 'assigned'
      this.handleRefresh()
    },
    handleTabChange() {
      this.pagination.current = 1
      this.jumpPage = 1
      this.selectedRowKeys = []
      this.selectedRows = []
      this.fetchData()
    },
    buildParams() {
      return {
        attendanceId: this.attendanceId,
        projectName: this.queryParam.projectName,
        employeeName: this.queryParam.employeeName,
        jobName: this.queryParam.jobName,
        wristbandName: this.queryParam.wristbandName,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }
    },
    handleQuery() {
      this.pagination.current = 1
      this.jumpPage = 1
      this.fetchData()
    },
    handleReset() {
      this.queryParam = {
        projectName: undefined,
        employeeName: undefined,
        jobName: undefined,
        wristbandName: undefined,
      }
      this.handleQuery()
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleRefresh() {
      this.fetchData()
    },
    handleTableChange(pagination, filters, sorter) {
      // 现在分页不在表格内部，这里主要处理排序
      if (sorter && sorter.field) {
        console.log('排序字段:', sorter.field, '排序方向:', sorter.order)
      }
    },

    /**
     * 每页条数变化
     * @param {Number} current - 当前页码
     * @param {Number} pageSize - 每页条数
     */
    onShowSizeChange(current, pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.current = 1
      this.jumpPage = 1
      this.fetchData()
    },

    /**
     * 分页变化
     * @param {Number} current - 当前页码
     * @param {Number} pageSize - 每页条数
     */
    changeSize(current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.jumpPage = current
      this.onSelectChange([], [])
      this.fetchData()
    },

    /**
     * 跳转页码
     */
    handleJumpPage() {
      if (this.jumpPage && this.jumpPage >= 1) {
        const maxPage = Math.ceil(this.pagination.total / this.pagination.pageSize)
        if (this.jumpPage > maxPage) {
          this.jumpPage = maxPage
        }
        this.pagination.current = this.jumpPage
        this.onSelectChange([], [])
        this.fetchData()
      }
    },
    fetchData() {
      if (this.activeTab === 'unassigned') {
        const projectId = this.$store.getters.currentProjectId
        if (!projectId) {
          this.tableData = []
          this.pagination.total = 0
          this.$message.warning('请先选择项目')
          return
        }
        this.loading = true
        const params = {
          ...this.buildParams(),
          projectId,
        }
        delete params.attendanceId
        listUnassignedEmployees(params)
          .then((res) => {
            this.tableData = (res.data && res.data.records) || []
            this.pagination.total = (res.data && res.data.total) || 0
            this.jumpPage = this.pagination.current
          })
          .finally(() => {
            this.loading = false
          })
        return
      }
      if (!this.attendanceId) {
        this.tableData = []
        this.pagination.total = 0
        return
      }
      this.loading = true
      pageWristbandEmployees(this.buildParams())
        .then((res) => {
          this.tableData = (res.data && res.data.records) || []
          this.pagination.total = (res.data && res.data.total) || 0
          this.jumpPage = this.pagination.current
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleAssign() {
      if (!this.attendanceId) {
        this.$message.warning('缺少考勤规则')
        return
      }
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请先选择未排班人员')
        return
      }
      this.assignLoading = true
      assignEmployees({
        attendanceId: this.attendanceId,
        userIds: this.selectedRowKeys,
      })
        .then(() => {
          this.$message.success('分配成功')
          this.selectedRowKeys = []
          this.selectedRows = []
          this.fetchData()
        })
        .finally(() => {
          this.assignLoading = false
        })
    },
    handleUnassign() {
      if (!this.attendanceId) {
        this.$message.warning('缺少考勤规则')
        return
      }
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请先选择已排班人员')
        return
      }
      const that = this
      this.$confirm({
        title: '确认移出当前班次?',
        content: '将清空所选人员的考勤规则绑定',
        onOk() {
          that.assignLoading = true
          return unassignEmployees({
            attendanceId: that.attendanceId,
            userIds: that.selectedRowKeys,
          })
            .then(() => {
              that.$message.success('已移出当前班次')
              that.selectedRowKeys = []
              that.selectedRows = []
              that.fetchData()
            })
            .finally(() => {
              that.assignLoading = false
            })
        },
      })
    },
    handleExport() {
      this.$message.info('员工列表导出功能暂未接入后端', 3)
    },
    handleClose() {
      $emit(this, 'update:visible', false)
      this.tableData = []
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    /**
     * 处理表格行选择变化
     * @param {Array} selectedRowKeys - 选中的行key数组
     * @param {Array} selectedRows - 选中的行数据数组
     */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
  },
  emits: ['update:visible'],
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 80px;
  min-width: 80px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 80px;
  text-align: right;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  width: 220px !important;
  background: #FFFFFF !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  width: 220px !important;
  background: #FFFFFF !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

/* 按钮区域样式 */
.table-page-search-submitButtons {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 确保按钮的 form-item 与输入框对齐 */
.table-page-search-wrapper :deep(.ant-form-item:not(.ant-form-item-with-help)) {
  margin-bottom: 0;
}

/* 展开状态下第二行恢复默认间距 */
.table-page-search-wrapper .second-row-col {
  margin-top: 16px;
}

.table-page-search-wrapper .second-row-col :deep(.ant-form-item) {
  margin-bottom: 0;
}

.table-page-search-wrapper :deep(.ant-form-item-control) {
  line-height: 32px;
}

/* 按钮 form-item 样式优化 - 确保与输入框完美对齐 */
.table-page-search-wrapper :deep(.button-form-item) {
  margin-bottom: 0;
}

.table-page-search-wrapper :deep(.button-form-item .ant-form-item-label) {
  display: none !important;
}

.table-page-search-wrapper :deep(.button-form-item .ant-form-item-control) {
  flex: 1 1 auto;
  margin-left: 0 !important;
  line-height: 32px;
}

.table-page-search-wrapper :deep(.button-form-item .ant-form-item-control-input) {
  min-height: 32px;
  display: flex;
  align-items: center;
}

.table-page-search-wrapper :deep(.button-form-item .ant-form-item-control-input-content) {
  display: flex;
  align-items: center;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
}

/* 展开/收起按钮样式 - 蓝色 */
.toggle-button {
  background: transparent !important;
  color: #165DFF !important;
  border: none !important;
}

.toggle-button:hover {
  background: transparent !important;
  color: #4080ff !important;
  border: none !important;
}

.toggle-button:focus {
  background: transparent !important;
  color: #165DFF !important;
  border: none !important;
}

.toggle-button :deep(.anticon) {
  color: inherit !important;
}

/* 重置按钮样式 */
.reset-button {
  background-color: #F3F3F3 !important;
  color: #333333 !important;
  border-color: #F3F3F3 !important;
  border-radius: 4px !important;
}

.reset-button:hover {
  background-color: #E6E6E6 !important;
  color: #333333 !important;
  border-color: #E6E6E6 !important;
}

.reset-button:focus {
  background-color: #F3F3F3 !important;
  color: #333333 !important;
  border-color: #F3F3F3 !important;
}

/* 导出按钮样式 */
.export-button {
  background-color: #F3F3F3 !important;
  color: #333333 !important;
  border-color: #F3F3F3 !important;
  border-radius: 4px !important;
}

.export-button:hover {
  background-color: #E6E6E6 !important;
  color: #333333 !important;
  border-color: #E6E6E6 !important;
}

.export-button:focus {
  background-color: #F3F3F3 !important;
  color: #333333 !important;
  border-color: #F3F3F3 !important;
}

.export-button :deep(.anticon) {
  color: #333333 !important;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.employee-tabs {
  margin-bottom: 8px;
}
.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.refresh-icon-button img {
  width: 32px;
  height: 32px;
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px;
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #FFFFFF !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

/* 表格复选框列固定左侧样式 */
.optimized-table :deep(.ant-table-thead > tr > th:first-child) {
  position: sticky;
  left: 0;
  background: #fafafa;
  z-index: 12;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr > td:first-child) {
  position: sticky;
  left: 0;
  background: white;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected > td:first-child) {
  position: sticky;
  left: 0;
  background: white !important;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td:first-child) {
  position: sticky;
  left: 0;
  background: #f5f5f5 !important;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 复选框列中的复选框层级 */
.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox-wrapper),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox-wrapper) {
  position: relative;
  z-index: 13;
}

.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox) {
  position: relative;
  z-index: 13;
}

.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox-inner),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox-inner) {
  position: relative;
  z-index: 13;
}

/* 分页组件样式 - 参照 ../index.vue 页面 */
.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn),
.pagination-wrapper :deep(.ant-pagination-item),
.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 4px !important;
}

/* 分页中的输入框圆角为4px - 覆盖 no-border-radius 类 */
.pagination-wrapper :deep(.ant-input-number),
.pagination-wrapper :deep(.no-border-radius-input-number),
.pagination-wrapper :deep(.no-border-radius-input-number .ant-input-number),
.pagination-wrapper :deep(.no-border-radius-input-number .ant-input-number-input),
.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 4px !important;
}

/* 分页中的选择框圆角为4px - 覆盖 no-border-radius 类 */
.pagination-wrapper :deep(.ant-select-selector),
.pagination-wrapper :deep(.no-border-radius-select),
.pagination-wrapper :deep(.no-border-radius-select .ant-select-selector),
.pagination-wrapper :deep(.ant-select-focused .ant-select-selector),
.pagination-wrapper :deep(.no-border-radius-select.ant-select-focused .ant-select-selector),
.pagination-wrapper :deep(.no-border-radius-select .ant-select-focused .ant-select-selector) {
  border-radius: 4px !important;
}

/* 分页选中页数样式 - 蓝色背景白色文字 - 全局样式确保生效 */
.pagination-wrapper :deep(.ant-pagination-item-active),
.pagination-wrapper :deep(.ant-pagination-item.ant-pagination-item-active) {
  background: #165DFF !important;
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a),
.pagination-wrapper :deep(.ant-pagination-item-active a:hover),
.pagination-wrapper :deep(.ant-pagination-item-active a:focus),
.pagination-wrapper :deep(.ant-pagination-item-active a:visited),
.pagination-wrapper :deep(.ant-pagination-item.ant-pagination-item-active a),
.pagination-wrapper :deep(.ant-pagination-item.ant-pagination-item-active a:hover),
.pagination-wrapper :deep(.ant-pagination-item.ant-pagination-item-active a:focus) {
  color: #FFFFFF !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover),
.pagination-wrapper :deep(.ant-pagination-item.ant-pagination-item-active:hover) {
  background: #165DFF !important;
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a),
.pagination-wrapper :deep(.ant-pagination-item.ant-pagination-item-active:hover a) {
  color: #FFFFFF !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:focus),
.pagination-wrapper :deep(.ant-pagination-item.ant-pagination-item-active:focus) {
  background: #165DFF !important;
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:focus a),
.pagination-wrapper :deep(.ant-pagination-item.ant-pagination-item-active:focus a) {
  color: #FFFFFF !important;
}
</style>
